import { createListenerMiddleware } from '@reduxjs/toolkit';
import { RootState, AppDispatch } from '..';
import { creatorActions } from '../slices/creatorSlice';

export const creatorMiddleware = createListenerMiddleware();

creatorMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.selectAttributeValue,
	effect: async ({ payload }, listenerApi) => {
		const { availableProducts, selectedValues } =
			listenerApi.getState().creator;

		listenerApi.cancelActiveListeners();

		await listenerApi.delay(250);
		const values = Object.values(selectedValues);

		if (values.some((value) => !value)) {
			listenerApi.dispatch(
				creatorActions.updateCreator({
					matchedProduct: null,
				})
			);
			return;
		}

		const matchedProduct = availableProducts.find((product) =>
			values.every((value) =>
				product.attributeValues.some(
					(productValue) => productValue.id === value!.id
				)
			)
		);

		if (!matchedProduct) return;

		listenerApi.dispatch(
			creatorActions.updateCreator({
				matchedProduct,
			})
		);
	},
});
